import lodash from "lodash";
//import moment from "moment";
import { defineAsyncComponent } from "vue";
import {
    createFieldInput,
    createFieldInputNumber,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTemplateBuilder
} from "../../../../components/input/template-builder/template-builder.logic";
import { createColumnInput, createColumnInputNumber } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { conditionFormChecker, putField } from "../../../../utils/form";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import { callGetStorageLocationSubReserveAndUse } from "../buy/storage-location/storage-location.logic";
import { callGetHazLicenseReserveAndUse } from "../buy/buy.section";
import moment from "moment/moment";
import { dateFormat } from "../../../../utils/date";

const Number = defineAsyncComponent(() => import("../../../../components/table/custom-render/Number"));

export const callHazMgtType = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_MGT_TYPE", value: searchQuery })
        .then(items => items.filter(item => ["3", "4"].includes(item.key)));
export const callHazLicense = ({ searchQuery /* , refUserCompanyId */, refUserCompanyId2, refHazId, refStorageLocationId, refOperationKeys }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" }
        //{ name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") }
    ];
    /*
    if (refUserCompanyId) {
        where.push({
            name: "items.refStorageLocationSub.refStorageLocation.refUserCompany.id",
            type: "UUID",
            operator: "=",
            value: refUserCompanyId
        });
    }
    */
    if (refUserCompanyId2) {
        where.push({
            name: "refUserCompany.id",
            type: "UUID",
            operator: "=",
            value: refUserCompanyId2
        });
    }
    if (refHazId) {
        where.push({
            name: "hazLicenseDetails.refHaz.id",
            type: "UUID",
            operator: "=",
            value: refHazId
        });
    }
    if (refStorageLocationId) {
        where.push({
            name: "hazLicenseStorageLocations.refStorageLocation.id",
            type: "UUID",
            operator: "=",
            value: refStorageLocationId
        });
    }
    if (refOperationKeys?.length > 0) {
        where.push({ name: "refOperation.key", type: "String", operator: "in", value: refOperationKeys });
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/hazLicense/search", {
            criteria: {
                isDistinct: true,
                select: [
                    "id",
                    "version",
                    "approveCode",
                    "effectiveDate",
                    "expireDate",
                    "refOperation.id",
                    "refOperation.version",
                    "refOperation.key",
                    "refOperation.value",
                    "refOperation.seq",
                    "quantity",
                    "quantityReserve",
                    "quantityUse"
                ],
                children: [
                    {
                        name: "hazLicenseDetails",
                        select: ["id", "refHaz.id", "refHaz.refHazObject.id", "refHaz.refHazObject.nameTh", "refHaz.tradeNameTh"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    }
                ],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};
export const callHaz = ({ searchQuery, hazLicenseId }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        //{ name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") },
        { name: "items.refHazLicense.id", type: "UUID", operator: "=", value: hazLicenseId }
    ];
    if (searchQuery) {
        where.push({ openBucket: true, name: "approveCode", type: "String", operator: "like", value: searchQuery });
        where.push({ logic: "OR", name: "refHazObject.nameTh", type: "String", operator: "like", value: searchQuery });
        where.push({ closeBucket: true, logic: "OR", name: "tradeNameTh", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/haz/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "approveCode", "refHazObject.id", "refHazObject.nameTh", "tradeNameTh", "refOperation.id", "refOperation.version", "refOperation.value"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};
export const callStorageLocation = ({ searchQuery, refHazId, refHazLicenseId, refHazLicenseId2 }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "isLocation", type: "Boolean", operator: "=", value: true }
    ];
    if (refHazId) {
        where.push({ name: "items.refHaz.id", type: "UUID", operator: "=", value: refHazId });
    }
    if (refHazLicenseId) {
        where.push({ name: "items.refHazLicense.id", type: "UUID", operator: "=", value: refHazLicenseId });
    }
    if (refHazLicenseId2) {
        where.push({ name: "hazLicenseStorageLocations.refHazLicense.id", type: "UUID", operator: "=", value: refHazLicenseId2 });
    }
    if (searchQuery) {
        where.push({ openBucket: true, name: "name", type: "String", operator: "like", value: searchQuery });
        where.push({ closeBucket: true, logic: "OR", name: "refUserCompany.fullNameTh", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/storageLocation/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "name", "refUserCompany.id", "refUserCompany.fullNameTh"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "refUserCompany.fullNameTh", type: "ASC" }, { name: "name", type: "ASC" }],
                children: []
            }
        })
        .then(page => page.data);
};
export const callStorageLocationSub = ({ searchQuery, refStorageLocationId, notId }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "refStorageLocation.id", type: "UUID", operator: "=", value: refStorageLocationId }
    ];
    if (notId) {
        where.push({ name: "id", type: "UUID", operator: "!=", value: notId });
    }
    if (searchQuery) {
        where.push({ name: "name", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/storageLocationSub/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "buildingName", "useKg", "useKgReserve", "useKgUse"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "buildingName", type: "ASC" }],
                children: []
            }
        })
        .then(page => page.data);
};
export const callStorageLocationSubItem = ({ searchQuery, refStorageLocationSubId, refHazLicenseId }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "refStorageLocationSub.id", type: "UUID", operator: "=", value: refStorageLocationSubId },
        { name: "refHazLicense.id", type: "UUID", operator: "=", value: refHazLicenseId }
    ];
    if (searchQuery) {
        where.push({ name: "lot", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/storageLocationSubItem/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "version", "lot", "reserveOut", "amount"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "lot", type: "ASC" }],
                children: []
            }
        })
        .then(page => page.data);
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.hazMgt.info.userCompany"),
            dataIndex: "refFrom.fullNameTh",
            dataIndexValue: ({ record }) => {
                return record.refFrom?.refPersonType?.key === "1" ? record.refFrom?.companyNameTh : record.refFrom?.fullNameTh;
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refHaz"),
            dataIndex: "storageLocations.0.refHaz.approveCode",
            align: "center",
            search: { name: "storageLocations.refHaz.approveCode" },
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.tradeNameTh"),
            dataIndex: "storageLocations.0.refHaz.tradeNameTh",
            search: { name: "storageLocations.refHaz.tradeNameTh" },
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocationSubItem"),
            dataIndex: "storageLocations.0.refStorageLocationSubItem.lot",
            align: "center",
            width: 200,
            search: { name: "storageLocations.refStorageLocationSubItem.lot" },
        }),
        createColumnInput({
            title: () => i18n.global.t("views.transfer.hazLicense"),
            dataIndex: "storageLocations.0.refHazLicenseFrom.approveCode",
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.transfer.objective"),
            dataIndex: "storageLocations.0.refHazLicenseFrom.refOperation.value",
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocation"),
            dataIndex: "storageLocations.0.refStorageLocation.name",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.transfer.hazLicense"),
            dataIndex: "storageLocations.0.refHazLicenseTo.approveCode",
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.transfer.objective"),
            dataIndex: "storageLocations.0.refHazLicenseTo.refOperation.value",
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocation"),
            dataIndex: "storageLocations.0.stores.0.refStorageLocation.name",
            search: { visible: () => false }
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.hazMgtStorageLocation.amount"),
            dataIndex: "storageLocations.0.amount",
            align: "center",
            search: { visible: () => false }
        })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refType`,
                colProp: () => ({ xs: 24, class: "mb-3" }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 }, colon: false }),
                label: () => i18n.global.t("model.hazMgt.refType"),
                labelRender: () => " ",
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refType,
                            "onUpdate:value": value => {
                                model.refType = value;
                                model.storageLocations[0].refHazLicenseTo = null;
                                if (value?.key === "3") {
                                    if (model.storageLocations[0].refHazLicenseFrom) {
                                        model.storageLocations[0].refHazLicenseTo = model.storageLocations[0].refHazLicenseFrom;
                                    }
                                    model.storageLocations[0].stores[0].refStorageLocation = null;
                                    model.storageLocations[0].stores[0].refStorageLocationSub = null;
                                } else if (value?.key === "4") {
                                    model.storageLocations[0].stores[0].refStorageLocation = model.storageLocations[0].refStorageLocation;
                                    model.storageLocations[0].stores[0].refStorageLocationSub = model.storageLocations[0].refStorageLocationSub;
                                }
                            },
                            disabled: viewOnly,
                            list: callHazMgtType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                cardBorderProp: () => ({ title: i18n.global.t("views.transfer.source") }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}storageLocations.0.refHazLicenseFrom`,
                            colProp: () => ({ xs: 20 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.transfer.hazLicense"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.storageLocations[0]?.refHazLicenseFrom,
                                        "onUpdate:value": value => {
                                            model.storageLocations[0].refHazLicenseFrom = value;
                                            model.storageLocations[0].refHaz = null;
                                            model.storageLocations[0].refStorageLocation = null;
                                            model.storageLocations[0].refStorageLocationSub = null;
                                            model.storageLocations[0].refStorageLocationSubItem = null;
                                            model.storageLocations[0].amount = null;

                                            if (model.refType?.key === "3") {
                                                model.storageLocations[0].refHazLicenseTo = value;
                                            } else if (model.refType?.key === "4") {
                                                model.storageLocations[0].refHazLicenseTo = null;
                                            }
                                            model.storageLocations[0].stores[0].refStorageLocation = null;
                                            model.storageLocations[0].stores[0].refStorageLocationSub = null;

                                            if (value) {
                                                setIsLoadingApp(true);
                                                callGetHazLicenseReserveAndUse({ hazLicenseId: value.id })
                                                    .then(d => {
                                                        model.storageLocations[0].refHazLicenseFrom.quantityReserve = d.reserve;
                                                        model.storageLocations[0].refHazLicenseFrom.quantityUse = d.use;
                                                        if (model.refType?.key === "3") {
                                                            model.storageLocations[0].refHazLicenseTo.quantityReserve = d.reserve;
                                                            model.storageLocations[0].refHazLicenseTo.quantityUse = d.use;
                                                        }
                                                    })
                                                    .finally(() => setIsLoadingApp(false));
                                            }
                                        },
                                        disabled: viewOnly,
                                        list: ({ searchQuery }) =>
                                            callHazLicense({
                                                searchQuery,
                                                refUserCompanyId2: store.state.resource.auth.info?.user?.refParent?.id || store.state.resource.auth.info?.user?.id
                                            }).then(d => {
                                                d.forEach((item) => (item.disabled = (item.expireDate && moment().diff(item.expireDate, 'days') >= 0)));
                                                return d;
                                            }),
                                        renderLabel: ({ item }) => {
                                            const details = item.hazLicenseDetails?.map(d => `[${d.refHaz?.refHazObject?.nameTh}-${d.refHaz?.tradeNameTh}]`).join(", ");
                                            const expireStr = item.expireDate ? `(วันที่หมดอายุ: ${dateFormat({ text: item.expireDate, format: "DD/MM/YYYY" })})` : '';
                                            return <span>
                                                {item.approveCode} ({item.refOperation?.value}) {details} {expireStr}
                                            </span>
                                        }
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.approveCode`) }
                        }),
                        {
                            visible: () =>
                                conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field: { key: `${prefix}storageLocations.0.refHazLicenseFrom` } }
                                }),
                            colProp: () => ({ xs: 4, class: "d-flex" }),
                            formItemRender: () => {
                                const hazLicense = model.storageLocations[0]?.refHazLicenseFrom;
                                if (!hazLicense) return null;
                                const amount = hazLicense?.quantity - hazLicense?.quantityReserve - hazLicense?.quantityUse || 0;
                                return () => (
                                    <div class="m-auto ml-1">
                                        / <Number allowPrecision={true} text={amount}></Number> kg
                                    </div>
                                );
                            }
                        },
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}storageLocations.0.refHaz`,
                            colProp: () => ({ xs: 20 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazMgtStorageLocation.refHaz"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.storageLocations[0]?.refHaz,
                                        "onUpdate:value": value => {
                                            model.storageLocations[0].refHaz = value;
                                            model.storageLocations[0].refStorageLocation = null;
                                            model.storageLocations[0].refStorageLocationSub = null;
                                            model.storageLocations[0].refStorageLocationSubItem = null;
                                            model.storageLocations[0].amount = null;
                                            if (model.refType?.key === "4") {
                                                model.storageLocations[0].refHazLicenseTo = null;
                                            }
                                            model.storageLocations[0].stores[0].refStorageLocation = null;
                                            model.storageLocations[0].stores[0].refStorageLocationSub = null;
                                        },
                                        disabled: viewOnly || !model.storageLocations[0].refHazLicenseFrom,
                                        list: ({ searchQuery }) =>
                                            callHaz({
                                                searchQuery,
                                                hazLicenseId: model.storageLocations[0].refHazLicenseFrom?.id
                                            }),
                                        renderLabel: ({ item }) => {
                                            return <span>{item.approveCode}-{item.tradeNameTh || "ไม่มีข้อมูล"}-{item.refHazObject?.nameTh || "ไม่มีข้อมูล"}</span>;
                                        },
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.approveCode`) }
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}storageLocations.0.refHaz.tradeNameTh`,
                            colProp: () => ({ xs: 20 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.haz.tradeNameTh"),
                            inputProp: ({ field }) => {
                                return lodash.merge(
                                    {
                                        value: model.storageLocations[0]?.refHaz?.tradeNameTh,
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                );
                            }
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}storageLocations.0.refStorageLocation`,
                            colProp: () => ({ xs: 20 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocation"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.storageLocations[0]?.refStorageLocation,
                                        "onUpdate:value": value => {
                                            model.storageLocations[0].refStorageLocation = value;
                                            model.storageLocations[0].refStorageLocationSub = null;
                                            model.storageLocations[0].refStorageLocationSubItem = null;
                                            model.storageLocations[0].amount = null;
                                            if (model.refType?.key === "4") {
                                                model.storageLocations[0].refHazLicenseTo = null;
                                                model.storageLocations[0].stores[0].refStorageLocation = value;
                                                model.storageLocations[0].stores[0].refStorageLocationSub = null;
                                            }
                                        },
                                        disabled: viewOnly || !model.storageLocations[0]?.refHaz || !model.storageLocations[0]?.refHazLicenseFrom,
                                        list: ({ searchQuery }) =>
                                            callStorageLocation({
                                                searchQuery,
                                                refHazId: model.storageLocations[0]?.refHaz?.id,
                                                refHazLicenseId: model.storageLocations[0]?.refHazLicenseFrom?.id
                                            }),
                                        renderLabel: ({ item }) => {
                                            return <span>{item.refUserCompany?.fullNameTh} - {item.name}</span>;
                                        },
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.name`) }
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}storageLocations.0.refStorageLocationSub`,
                            colProp: () => ({ xs: 20 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocationSub"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.storageLocations[0]?.refStorageLocationSub,
                                        "onUpdate:value": value => {
                                            model.storageLocations[0].refStorageLocationSub = value;
                                            model.storageLocations[0].refStorageLocationSubItem = null;
                                            model.storageLocations[0].amount = null;
                                            if (model.refType?.key === "4") {
                                                model.storageLocations[0].stores[0].refStorageLocationSub = value;
                                            }
                                            if (value) {
                                                setIsLoadingApp(true);
                                                callGetStorageLocationSubReserveAndUse({ stroageLocationSubId: value.id })
                                                    .then(d => {
                                                        model.storageLocations[0].refStorageLocationSub.useKgReserve = d.reserve;
                                                        model.storageLocations[0].refStorageLocationSub.useKgUse = d.use;
                                                        if (model.refType?.key === "4") {
                                                            model.storageLocations[0].stores[0].refStorageLocationSub.useKgReserve = d.reserve;
                                                            model.storageLocations[0].stores[0].refStorageLocationSub.useKgUse = d.use;
                                                        }
                                                    })
                                                    .finally(() => setIsLoadingApp(false));
                                            }
                                        },
                                        disabled: viewOnly || !model.storageLocations[0]?.refStorageLocation,
                                        list: ({ searchQuery }) =>
                                            callStorageLocationSub({
                                                searchQuery,
                                                refStorageLocationId: model.storageLocations[0]?.refStorageLocation?.id,
                                                notId: model.storageLocations[0]?.stores?.[0]?.refStorageLocationSub?.id
                                            }),
                                        optLabel: "buildingName"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.buildingName`) }
                        }),
                        {
                            visible: () =>
                                conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field: { key: `${prefix}storageLocations.0.refStorageLocationSub` } }
                                }),
                            colProp: () => ({ xs: 4, class: "d-flex" }),
                            formItemRender: () => {
                                const sub = model.storageLocations[0]?.refStorageLocationSub;
                                if (!sub) return null;
                                const amount = sub?.useKg - sub?.useKgUse - sub?.useKgReserve || 0;
                                return () => (
                                    <div class="m-auto ml-1">
                                        / <Number allowPrecision={true} text={amount}></Number> kg
                                    </div>
                                );
                            }
                        },
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}storageLocations.0.refStorageLocationSubItem`,
                            colProp: () => ({ xs: 20 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocationSubItem"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.storageLocations[0]?.refStorageLocationSubItem,
                                        "onUpdate:value": value => {
                                            model.storageLocations[0].refStorageLocationSubItem = value;
                                            model.storageLocations[0].amount = null;
                                        },
                                        disabled: viewOnly || !model.storageLocations[0]?.refStorageLocationSub,
                                        list: ({ searchQuery }) =>
                                            callStorageLocationSubItem({
                                                searchQuery,
                                                refStorageLocationSubId: model.storageLocations[0]?.refStorageLocationSub?.id,
                                                refHazLicenseId: model.storageLocations[0]?.refHazLicenseFrom?.id
                                            }),
                                        optLabel: "lot"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.lot`) }
                        }),
                        createFieldInputNumber({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}storageLocations.0.amount`,
                            colProp: () => ({ xs: 20 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazMgtStorageLocation.amount"),
                            inputProp: ({ field }) => {
                                return lodash.merge(
                                    {
                                        value: model.storageLocations[0]?.amount,
                                        "onUpdate:value": value => {
                                            model.storageLocations[0].amount = value;
                                            model.storageLocations[0].stores[0].amount = value;
                                        },
                                        disabled: viewOnly || !model.storageLocations[0]?.refStorageLocationSubItem,
                                        allowPrecision: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                );
                            }
                        }),
                        {
                            visible: () =>
                                conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field: { key: `${prefix}storageLocations.0.refStorageLocationSubItem` } }
                                }),
                            colProp: () => ({ xs: 4, class: "d-flex" }),
                            formItemRender: () => {
                                const item = model.storageLocations[0]?.refStorageLocationSubItem;
                                if (!item) return null;
                                const amount = item.amount - item.reserveOut || 0;
                                return () => (
                                    <div class="m-auto ml-1">
                                        / <Number allowPrecision={true} text={amount}></Number> kg
                                    </div>
                                );
                            }
                        }
                    ]
                })
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                cardBorderProp: () => ({ title: i18n.global.t("views.transfer.desctination") }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}storageLocations.0.refHazLicenseTo`,
                            colProp: () => ({ xs: 20 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.transfer.hazLicense"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.storageLocations[0]?.refHazLicenseTo,
                                        "onUpdate:value": value => {
                                            model.storageLocations[0].refHazLicenseTo = value;
                                            if (value) {
                                                setIsLoadingApp(true);
                                                callGetHazLicenseReserveAndUse({ hazLicenseId: value.id })
                                                    .then(d => {
                                                        model.storageLocations[0].refHazLicenseTo.quantityReserve = d.reserve;
                                                        model.storageLocations[0].refHazLicenseTo.quantityUse = d.use;
                                                    })
                                                    .finally(() => setIsLoadingApp(false));
                                            }
                                        },
                                        disabled:
                                            viewOnly ||
                                            !model.storageLocations[0]?.refHazLicenseFrom ||
                                            !model.storageLocations[0]?.refHaz ||
                                            !model.storageLocations[0]?.refStorageLocation,
                                        list: ({ searchQuery }) => {
                                            let refOperationKey = model.storageLocations[0]?.refHazLicenseFrom?.refOperation?.key;
                                            let refOperationKeys = [];
                                            if (refOperationKey === "1") {
                                                refOperationKeys = ["2", "5"];
                                            } else if (refOperationKey === "2") {
                                                refOperationKeys = ["5"];
                                            } else if (refOperationKey === "4") {
                                                refOperationKeys = ["2", "5"];
                                            } else if (refOperationKey === "5") {
                                                refOperationKeys = ["2"];
                                            }
                                            return callHazLicense({
                                                searchQuery,
                                                refUserCompanyId2: store.state.resource.auth.info?.user?.refParent?.id || store.state.resource.auth.info?.user?.id,
                                                refHazId: model.storageLocations[0]?.refHaz?.id,
                                                refStorageLocationId: model.storageLocations[0]?.refStorageLocation?.id,
                                                refOperationKeys
                                            }).then(d => {
                                                d.forEach((item) => (item.disabled = (item.expireDate && moment().diff(item.expireDate, 'days') >= 0)));
                                                return d;
                                            });
                                        },
                                        renderLabel: ({ item }) => {
                                            const details = item.hazLicenseDetails?.map(d => `[${d.refHaz?.refHazObject?.nameTh}-${d.refHaz?.tradeNameTh}]`).join(", ");
                                            const expireStr = item.expireDate ? `(วันที่หมดอายุ: ${dateFormat({ text: item.expireDate, format: "DD/MM/YYYY" })})` : '';
                                            return <span>
                                                {item.approveCode} ({item.refOperation?.value}) {details} {expireStr}
                                            </span>
                                        }
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.approveCode`) }
                        }),
                        {
                            visible: () =>
                                conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field: { key: `${prefix}storageLocations.0.refHazLicenseTo` } }
                                }),
                            colProp: () => ({ xs: 4, class: "d-flex" }),
                            formItemRender: () => {
                                const hazLicense = model.storageLocations[0]?.refHazLicenseTo;
                                if (!hazLicense) return null;
                                const amount = hazLicense?.quantity - hazLicense?.quantityReserve - hazLicense?.quantityUse || 0;
                                return () => (
                                    <div class="m-auto ml-1">
                                        / <Number allowPrecision={true} text={amount}></Number> kg
                                    </div>
                                );
                            }
                        },
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}storageLocations.0.stores.0.refStorageLocation`,
                            colProp: () => ({ xs: 20 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocation"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.storageLocations[0]?.stores?.[0]?.refStorageLocation,
                                        "onUpdate:value": value => {
                                            model.storageLocations[0].stores[0].refStorageLocation = value;
                                            model.storageLocations[0].stores[0].refStorageLocationSub = null;
                                        },
                                        disabled: viewOnly || !model.storageLocations[0]?.refHazLicenseFrom,
                                        list: ({ searchQuery }) =>
                                            callStorageLocation({
                                                searchQuery,
                                                refHazLicenseId2: model.storageLocations[0]?.refHazLicenseFrom?.id
                                            }),
                                        renderLabel: ({ item }) => {
                                            return <span>{item.refUserCompany?.fullNameTh} - {item.name}</span>;
                                        },
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.name`) }
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}storageLocations.0.stores.0.refStorageLocationSub`,
                            colProp: () => ({ xs: 20 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.hazMgtStorageLocation.refStorageLocationSub"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.storageLocations[0]?.stores?.[0]?.refStorageLocationSub,
                                        "onUpdate:value": value => {
                                            model.storageLocations[0].stores[0].refStorageLocationSub = value;
                                            if (value) {
                                                setIsLoadingApp(true);
                                                callGetStorageLocationSubReserveAndUse({ stroageLocationSubId: value.id })
                                                    .then(d => {
                                                        model.storageLocations[0].stores[0].refStorageLocationSub.useKgReserve = d.reserve;
                                                        model.storageLocations[0].stores[0].refStorageLocationSub.useKgUse = d.use;
                                                    })
                                                    .finally(() => setIsLoadingApp(false));
                                            }
                                        },
                                        disabled: viewOnly || !model.storageLocations[0]?.stores?.[0]?.refStorageLocation,
                                        list: ({ searchQuery }) =>
                                            callStorageLocationSub({
                                                searchQuery,
                                                refStorageLocationId: model.storageLocations[0]?.stores?.[0]?.refStorageLocation?.id,
                                                notId: model.storageLocations[0]?.refStorageLocationSub?.id
                                            }),
                                        optLabel: "buildingName"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.buildingName`) }
                        }),
                        {
                            visible: () =>
                                conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field: { key: `${prefix}storageLocations.0.stores.0.refStorageLocationSub` } }
                                }),
                            colProp: () => ({ xs: 4, class: "d-flex" }),
                            formItemRender: () => {
                                const sub = model.storageLocations[0]?.stores?.[0]?.refStorageLocationSub;
                                if (!sub) return null;
                                const amount = sub?.useKg - sub?.useKgUse - sub?.useKgReserve || 0;
                                return () => (
                                    <div class="m-auto ml-1">
                                        / <Number allowPrecision={true} text={amount}></Number> kg
                                    </div>
                                );
                            }
                        }
                    ]
                })
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => {
                    return <div class="text-danger">{i18n.global.t("views.transfer.remark")}</div>;
                }
            }
        ]
    });
};
